import { TOUR_TRANSLATIONS } from "../translations"

export const getShareSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="share-filters"]',
            title: t.shareFilters.title,
            content: t.shareFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="share-table"]',
            title: t.shareTable.title,
            content: t.shareTable.content,
        },
        {
            target: '[data-tour="share-sku-details"]',
            title: t.shareSkuDetails.title,
            content: t.shareSkuDetails.content,
        },
    ]
}
